import { DownloadOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Empty, Table, message } from "antd";
import { useEffect, useState } from "react";
import api from "../../../api/api";
import ExportExcel from "../../../Util/ExportExcel";
import { getLeadTypeLabel } from "../../../Util/GetLeadTypeLabel";
import JalaliDateCell from "../../../Components/Leads/JalaliDateCell";

const batchKey = (sequence) => sequence == null ? "unassigned" : String(sequence);
const batchLabel = (sequence) => sequence == null ? "بدون شماره" : `درخواست ${sequence}`;

const LeadExportBatches = ({ id, title, refreshKey, canExport }) => {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setBatches([]);
    api.get(`/lead-exports/${id}/item-batches`)
      .then((res) => { if (active) setBatches(res.data.data); })
      .catch((requestError) => {
        if (active) setError(requestError.response?.data?.error?.message || "خطا در دریافت درخواست‌های خروجی");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id, refreshKey, retry]);

  const downloadBatch = async (sequence) => {
    if (downloading !== null) return;
    const key = batchKey(sequence);
    setDownloading(key);
    try {
      const res = await api.get(`/lead-exports/${id}/item-batches/${key}`);
      const items = res.data.data;
      if (!items.length) {
        message.info("لیدی برای دانلود در این درخواست وجود ندارد.");
        return;
      }
      const rows = items.map((item) => ({
        mobile: item.user?.username ?? "",
        firstname: item.user?.firstname ?? "",
        lastname: item.user?.lastname ?? "",
        lead_type: getLeadTypeLabel(item.lead_type),
      }));
      const filename = `${title || "خروجی لید"}-${id}-${batchLabel(sequence)}`.replace(/[\\/:*?"<>|]/g, "-");
      await ExportExcel(rows, filename, { rtl: true });
    } catch (requestError) {
      message.error(requestError.response?.data?.error?.message || "خطا در دانلود فایل اکسل");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <Card title="دانلود اکسل لیدهای خروجی">
      {error ? <Alert type="error" message={error} action={
        <Button onClick={() => setRetry((value) => value + 1)}>تلاش مجدد</Button>
      } /> : !loading && !batches.length ? <Empty description="هنوز لیدی به این خروجی اضافه نشده است." /> : <Table
        rowKey={(batch) => batchKey(batch.sequence_number)}
        loading={loading}
        dataSource={batches}
        pagination={false}
        scroll={{ x: 600 }}
        locale={{ emptyText: "هنوز لیدی به این خروجی اضافه نشده است." }}
        columns={[
          { title: "شماره درخواست", dataIndex: "sequence_number", render: batchLabel },
          { title: "زمان ایجاد درخواست", dataIndex: "createdAt", render: (date) => <JalaliDateCell date={date} fallback="—" /> },
          { title: "تعداد لید", dataIndex: "items_count" },
          ...(canExport ? [{ title: "دانلود", key: "download", render: (_, batch) => (
            <Button
              icon={<DownloadOutlined />}
              loading={downloading === batchKey(batch.sequence_number)}
              disabled={downloading !== null}
              onClick={() => downloadBatch(batch.sequence_number)}
              aria-label={`دانلود اکسل ${batchLabel(batch.sequence_number)}`}
            >دانلود اکسل</Button>
          ) }] : []),
        ]}
      />}
    </Card>
  );
};

export default LeadExportBatches;
